'use strict';
var exports = require('client_core/search/search'); // $.extend({}, require('core/search/search'));

var setRefinementCollapseStates = status => {

    if (status === 'open') {
        $('.refinement').addClass('active');
    }
    else if (status === 'closed') {
        $('.refinement').removeClass('active');
        $('.refinement').find('button.title').attr('aria-expanded','false');
    }
};

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results, selector) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, selector);
}

function countSelectedRefinements() {
    var refinementList = ($('.js-refinements').attr('data-refinement-list'));
    if (refinementList !== undefined) {
        refinementList = JSON.parse(refinementList);

        if(window.isMobile()) {
            var filterText = $('.js-total-filter');
            filterText.empty();
            if (refinementList.length > 0) {
                filterText.append('(' + refinementList.length + ')');
            }

            var $refinementSlider = $('.refinement-slider');
            $refinementSlider.removeClass('in');
        }
        else {
            var refineOptions = $('.js-desktop-search-refinements').attr('data-refine-options');
            if (refineOptions !== undefined) {
                refineOptions = refineOptions.slice(1, -1);
                refineOptions = refineOptions.split(', ');
            }

            var choice = [0, 0, 0];

            var i = 0;

            for (i = 0; i < refinementList.length; i ++) {

                if (refinementList[i].id === refineOptions[0]) {
                    choice[0]++;
                }
                else if (refinementList[i].id === refineOptions[1]) {
                    choice[1]++;
                }
                else if (refinementList[i].id === refineOptions[2]) {
                    choice[2]++;
                }
            }

            for (i = 0; i < refineOptions.length; i ++) {
                var refineChoice = $('.js-button-' + refineOptions[i]);
                refineChoice.empty();
                if (choice[i] > 0) {
                    refineChoice.append('(' + choice[i] + ')');
                }
            }
        }
    }
    else {
        if(!window.isMobile()){
            var refineOptions = $('.js-desktop-search-refinements').attr('data-refine-options');
            if (refineOptions !== undefined) {
                refineOptions = refineOptions.slice(1, -1);
                refineOptions = refineOptions.split(', ');

                for (i = 0; i < refineOptions.length; i ++) {
                    var refineChoice = $('.js-button-' + refineOptions[i]);
                    refineChoice.empty();
                }
            }
        }
        else {
            var $refinementSlider = $('.refinement-slider');
            $refinementSlider.removeClass('in');
        }
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var isMobile = window.isMobile();

    if (isMobile) {
        var $refinements = $results.find('.refinements[data-refinement-style-mobile]');
        var refinementStyle = $refinements.data('refinement-style-mobile');
        var selector = `[data-refinement-style-mobile="${refinementStyle}"]`;
    } else {
        var $refinements = $results.find('.refinements[data-refinement-style-desktop]');
        var refinementStyle = $refinements.data('refinement-style-desktop');
        var selector = `[data-refinement-style-desktop="${refinementStyle}"]`;
    };

    var $filterBar = $results.find('.filter-bar');
    var filterBarStyle = !isMobile ? $filterBar.attr('data-filter-bar-style-desktop') : $filterBar.attr('data-filter-bar-style-mobile');
    var filterBar = !isMobile ? '[data-filter-bar-style-desktop="' + filterBarStyle + '"]' : '[data-filter-bar-style-mobile="' + filterBarStyle + '"]';

    var verticalMobile = isMobile && selector === '[data-refinement-style-mobile="vertical"]';
    var verticalDesktop = !isMobile && selector === '[data-refinement-style-desktop="vertical"]';
    var horizontalMultipleDropdownsDesktop = !isMobile && selector === '[data-refinement-style-desktop="horizontal-multiple-dropdowns"]';
    var horizontalOneDropdownDesktop = !isMobile && selector === '[data-refinement-style-desktop="horizontal-one-dropdown"]';
    var horizontalOneDropdownDesktopActive = $('.collapse-filters-wrapper').hasClass('active');
    var horizontalOneDropdownDesktopOpen = false;

    if (horizontalOneDropdownDesktop && horizontalOneDropdownDesktopActive) {
        horizontalOneDropdownDesktopOpen = true;
    }

    if (verticalMobile || verticalDesktop) {
        var specialHandlers = {
            selector : handleRefinements
        };

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results, selector);
        });
    };

    var isCustomBar = $('.js-desktop-search-refinements').attr('data-custom-refine-bar');
    if (isCustomBar === 'true') {
        var refinements = '.desktop-search-refinements';
    }
    else {
        if (!isMobile) {
            var refinements = '.desktop-search-refinements';
        } else {
            var refinements = '.mobile-search-refinements';
        };
    }

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.custom-refine-bar',
        '.search-result-count',
        refinements,
        filterBar
    ].forEach((selector) => {
        updateDom($results, selector);
        countSelectedRefinements();
    });

    if (horizontalOneDropdownDesktopOpen === true) {
        $('.collapse-filters-wrapper').addClass('active').css('display', 'block');
    }

    $('body').trigger('ajax:load.ajaxEvents', [$('.search-results')]);

    exports.refinementStickyBar();
    exports.oneDropdownSlideToggle();
}


exports.applyFilter = function () {
    var $xhr;
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (event) {
            var category = $(event.currentTarget).closest('.refinement');

            if (category && category.hasClass('refinement-category')) {
                localStorage.setItem('refinement-category', true);
                return;
            }
            //find new attr on Sort if selected, if not use the default
            var selectedSort = $('select[name="sort-order"]').find('option[selected="selected"]');
            if (selectedSort.data('id') != null) {
                var sortingRule = selectedSort.data('id');
            } else {
                var sortingRule = $('select[name="sort-order"] option:selected').data('id');
            }
            if (!$(this).data('href')) {
                return;
            }
            //create a new url with the correct preferences
            if ($(this).data('href').includes('srule')) {
                var refinementUrl = $(this).data('href').replace(/(srule=).*?(&|$)/,'$1' + sortingRule + '$2');
            } else if (!$(this).data('href').includes('srule') && sortingRule != null) {
                var split = $(this).data('href').indexOf('?') !== -1 ? '&' : '?';
                var refinementUrl = $(this).data('href') + split + 'srule=' + sortingRule;
            } else {
                var refinementUrl = $(this).data('href');
            }

            event.preventDefault();
            event.stopPropagation();
            $(this).trigger('search:filter', event);

            // Cancel previous request
            $xhr && $xhr.abort && $xhr.abort();

            $xhr = $.ajax({
                url: refinementUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: refinementUrl
                },
                method: 'GET',
                timeout: 15000,
                beforeSend: function () {
                    $.spinner().start();
                },
                success: function (response) {
                    parseResults(response);
                    // Update browser history with Search-Show specific route
                    var $results = $(response);
                    var historyUrl = $results.find('.history-url').data('history-url');
                    if (historyUrl) {
                        history.replaceState(undefined, '', historyUrl);
                    } else {
                        history.replaceState(undefined, '', refinementUrl);
                    }
                    $('body').trigger('search:filter--success');
                },
                complete: function () {
                    $.spinner().stop();
                    var $modalBackground = $('.modal-background');
                    $modalBackground.fadeOut(200);
                    countSelectedRefinements();
                }
            });
        });
};

var toggleRefinementDrawer = status => {
    var $refinementSlider = $('.refinement-slider');
    var $modalBackground = $('.modal-background');

    if (status === 'open') {
        var $header = $('#top-header');
        var $headerNav = $header.find('.header-nav');
        var headerNavClientRect = $headerNav.get(0).getBoundingClientRect();

        // show filter
        $('body').addClass('mobile-filter-drawer-in');
        // set refinement and modal top properties
        $refinementSlider.addClass('in').siblings().attr('aria-hidden', true);
        $modalBackground.fadeIn(200);

        $refinementSlider.closest('.row').siblings().attr('aria-hidden', true);
        $refinementSlider.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $refinementSlider.closest('.container.search-results').siblings().attr('aria-hidden', true);
        $refinementSlider.find('.close').focus();
    } else {
        // get the scrollY saved to body to use later for updating users scroll position when menu closes

        $('body').removeClass('mobile-filter-drawer-in');
        $refinementSlider.removeClass('in').css('top', '').siblings().attr('aria-hidden', false);
        $modalBackground.fadeOut(200);
        $refinementSlider.closest('.row').siblings().attr('aria-hidden', false);
        $refinementSlider.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $refinementSlider.closest('.container.search-results').siblings().attr('aria-hidden', false);
        $modalBackground.removeClass('custom-refinebar');
        $('.btn.filter-results').focus();
    }
};

exports.closeRefinements = function () {

    $('html').on('click', '.refinement-bar button.close, .mobile-filter-drawer-in .modal-background', () => toggleRefinementDrawer('close'));
    //for horizontal one dropdown menu
}

function toggleSelectSort(event) {
    var newSortSelect = $(event.target).parent();
    var sortOption = newSortSelect.data('id');
    if (!newSortSelect.hasClass('option-selected')) {
        var oldSelect = $('.js-sort-order-custom').find('.option-selected').removeClass('option-selected');
        oldSelect.find('.fa-check-circle').addClass('fa-circle-o').removeClass('fa-check-circle');
        oldSelect.find('.selected').removeClass('selected');
        newSortSelect.addClass('option-selected').find('.fa-circle-o').removeClass('fa-circle-o').addClass('fa-check-circle');
        newSortSelect.find('.sort-by').addClass('selected');


        var sortSelect = $('.js-select-dropdown option[data-id="'+sortOption+'"]');
        sortSelect.prop('selected', true);
        sortSelect.trigger('change');
    }
}

exports.initialize = () => $(document).ready(function () {
    var isMobile = window.isMobile();
    var collapseMobile = $('[data-collapse-mobile]').attr('data-collapse-mobile') === 'true' ? true : false;
    var collapseDesktop = $('[data-collapse-desktop]').attr('data-collapse-desktop') === 'true' ? true : false;
    if (isMobile && collapseMobile) {
        setRefinementCollapseStates('close');
    } else if (isMobile && !collapseMobile) {
        setRefinementCollapseStates('open');
    } else if (!isMobile && collapseDesktop) {
        setRefinementCollapseStates('close');
    } else if (!isMobile && !collapseDesktop) {
        setRefinementCollapseStates('open');
    }
    if ($('#articles-tab').hasClass('active') && $('#content-search-results').html() === '') {
        getContent($('.content-search'), $('#content-search-results'));
    }

    var refinementCategoryOpen = localStorage.getItem('refinement-category');
    if (refinementCategoryOpen) {
        $('.refinement-category').addClass('active');
    }
    countSelectedRefinements();
});

exports.selectSort = () => $('html').on('click', 'button.sort-button', (event) => toggleSelectSort(event));
exports.filter = () => {
    $('html').on('click', 'button.filter-slide-out', function(event) {
        var isCustomRefinebar = $(this).data('is-custom') || false;
        var $modalbackground = $('.modal-background');
        $modalbackground.toggleClass('custom-refinebar', isCustomRefinebar);
        toggleRefinementDrawer('open');
    });
}
exports.resize = () => {
    $(window).resize(() => {
        var windowWidth = $(window).width();

        if (!window.isMobile()) {
            toggleRefinementDrawer('close');
        }
        if (windowWidth !== $(window).width()) {
            windowWidth = $(window).width();
            toggleRefinementDrawer('close');
            exports.oneDropdownSlideToggle();
        }
        exports.oneDropdownSlideToggle();
    });
}

exports.yotpoRatings = () => {
    var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
    var integrationSettings = siteIntegrations.getIntegrationSettings();
    if (integrationSettings.yotpoCartridgeEnabled) {
        $('body').on('search:showMore--success search:filter--success search:sort--success', () => {
            if (window.yotpo) {
                window.refreshYotpoWidgets?.();
            }
        });
    }
}

module.exports = exports;
